import { useState } from 'react';

interface Props {
  src: string | null;
  alt: string;
  /** aspect ratio height/width; Yu-Gi-Oh cards are ~1.457. */
  className?: string;
}

/** Renders a card image, falling back to a text placeholder when missing or broken. */
export default function CardImage({ src, alt, className }: Props) {
  const [failed, setFailed] = useState(false);
  const showPlaceholder = !src || failed;

  if (showPlaceholder) {
    return (
      <div className={`card-img card-img--placeholder ${className ?? ''}`} aria-label={alt}>
        <span>No image</span>
      </div>
    );
  }

  return (
    <img
      className={`card-img ${className ?? ''}`}
      src={src}
      alt={alt}
      loading="lazy"
      draggable={false}
      onError={() => setFailed(true)}
    />
  );
}
